import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Table } from 'foundations-components/transitional/components/Table';
import { MediaQueryView } from 'marketplace-ui-common/layout/components/MediaQueryView';
import { useMemo } from 'react';
import { SharedDataTableRow } from './SharedDataTableRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function SharedDataTable({
  onTrackInteraction,
  sharedObjects,
  appObjects
}) {
  const groupedSharedObjects = useMemo(() => {
    const groupedSharedObjectsDictionary = sharedObjects === null || sharedObjects === void 0 ? void 0 : sharedObjects.reduce((acc, sharedObject) => {
      var _appObjects$find;
      const {
        sharedAppObject,
        sharedHubspotObject,
        sharedHubspotAppObject,
        sharedObjectDirection,
        sharedHubspotObjectType,
        sharedObjectDescription,
        customFieldMappings,
        defaultFieldMappings
      } = sharedObject;

      // Use first values from arrays for grouping
      const objectType = (sharedHubspotObjectType === null || sharedHubspotObjectType === void 0 ? void 0 : sharedHubspotObjectType[0]) || '';
      const pluralObjectName = (appObjects === null || appObjects === void 0 || (_appObjects$find = appObjects.find(appObject => appObject.name === sharedHubspotAppObject)) === null || _appObjects$find === void 0 || (_appObjects$find = _appObjects$find.data) === null || _appObjects$find === void 0 ? void 0 : _appObjects$find.pluralForm) || sharedHubspotAppObject;
      const objectName = objectType === 'APP_OBJECT' && pluralObjectName ? `${pluralObjectName.charAt(0).toUpperCase()}${pluralObjectName.slice(1).toLowerCase()}` : (sharedHubspotObject === null || sharedHubspotObject === void 0 ? void 0 : sharedHubspotObject[0]) || '';
      const direction = (sharedObjectDirection === null || sharedObjectDirection === void 0 ? void 0 : sharedObjectDirection[0]) || '';
      const description = sharedObjectDescription || '';

      // Group by app object, sync direction, and description
      // Include field mappings in key to ensure items with different mappings are separate
      const hasFieldMappings = ((customFieldMappings === null || customFieldMappings === void 0 ? void 0 : customFieldMappings.length) || 0) > 0 || ((defaultFieldMappings === null || defaultFieldMappings === void 0 ? void 0 : defaultFieldMappings.length) || 0) > 0;
      const key = `${sharedAppObject}-${direction}-${description}-${hasFieldMappings ? 'withMappings' : 'noMappings'}`;
      if (acc[key]) {
        acc[key].hubspotObjects.push(objectName);
        acc[key].sharedHubspotObjectType.push(objectType);
      } else {
        acc[key] = {
          sharedAppObject,
          sharedObjectDirection: direction,
          sharedObjectDescription: description,
          hubspotObjects: [objectName],
          sharedHubspotObjectType: [objectType],
          customFieldMappings,
          defaultFieldMappings
        };
      }
      return acc;
    }, {});
    const groupedSharedObjectArray = groupedSharedObjectsDictionary ? Object.values(groupedSharedObjectsDictionary) : [];
    return groupedSharedObjectArray.sort((a, b) => {
      var _a$sharedAppObject;
      return a === null || a === void 0 || (_a$sharedAppObject = a.sharedAppObject) === null || _a$sharedAppObject === void 0 ? void 0 : _a$sharedAppObject.localeCompare(b === null || b === void 0 ? void 0 : b.sharedAppObject);
    });
  }, [sharedObjects, appObjects]);
  const hasInteractableRows = useMemo(() => {
    return groupedSharedObjects === null || groupedSharedObjects === void 0 ? void 0 : groupedSharedObjects.some(groupedSharedObject => {
      var _groupedSharedObject$, _groupedSharedObject$2;
      return (((_groupedSharedObject$ = groupedSharedObject.customFieldMappings) === null || _groupedSharedObject$ === void 0 ? void 0 : _groupedSharedObject$.length) || 0) > 0 || (((_groupedSharedObject$2 = groupedSharedObject.defaultFieldMappings) === null || _groupedSharedObject$2 === void 0 ? void 0 : _groupedSharedObject$2.length) || 0) > 0;
    });
  }, [groupedSharedObjects]);
  return /*#__PURE__*/_jsxs(Table, {
    condensed: true,
    hover: hasInteractableRows,
    children: [/*#__PURE__*/_jsx("thead", {
      children: /*#__PURE__*/_jsxs("tr", {
        children: [/*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.functionalityCard.tabs.sharedData.table.header.dataSource"
          })
        }), /*#__PURE__*/_jsx("th", {
          children: /*#__PURE__*/_jsx(Flex, {
            justifyContent: "center",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "detailsPage.functionalityCard.tabs.sharedData.table.header.syncDirection"
            })
          })
        }), /*#__PURE__*/_jsxs("th", {
          children: [/*#__PURE__*/_jsx(MediaQueryView, {
            min: "xl",
            children: /*#__PURE__*/_jsx(Flex, {
              paddingInlineStart: "1500",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "detailsPage.functionalityCard.tabs.sharedData.table.header.inHubSpot"
              })
            })
          }), /*#__PURE__*/_jsx(MediaQueryView, {
            max: "xl",
            children: /*#__PURE__*/_jsx(Flex, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "detailsPage.functionalityCard.tabs.sharedData.table.header.inHubSpot"
              })
            })
          })]
        })]
      })
    }), /*#__PURE__*/_jsx("tbody", {
      children: groupedSharedObjects && groupedSharedObjects.map((groupedSharedObject, index) => /*#__PURE__*/_jsx(SharedDataTableRow, {
        groupedSharedObject: groupedSharedObject,
        index: index,
        onTrackInteraction: onTrackInteraction
      }, index))
    })]
  });
}